const KEY = 'theunc.portfolio.v1';

const SEED = [
  {
    id: 'talea',
    name: 'Talea',
    tagline: 'Latin for Tally.',
    status: 'Now shipping',
    year: '2025',
    featured: true,
    color: '#FFE8DD',
    glyphFg: '#FF4D00',
    glyph: 'T',
    description:
      "Ever wonder how many times your dog stole your socks, your roommate left dirty dishes in the sink, or your significant other reminded you to take out the trash? Talea is the hilariously simple way to track life's little annoyances (or joys) and see just how often they really happen. From daily nags to unexpected wins, log those silly, stupid, or surprisingly frequent events and watch the stats roll in.",
    appleLink: 'https://apps.apple.com/us/app/talea/id6740731835',
    version: 'v1.0',
    updated: 'recently',
  },
];

function read() {
  try {
    const raw = localStorage.getItem(KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    return Array.isArray(parsed) ? parsed : null;
  } catch (e) {
    return null;
  }
}

function write(apps) {
  localStorage.setItem(KEY, JSON.stringify(apps));
  window.dispatchEvent(new CustomEvent('theunc:portfolio-changed'));
}

function getAll() {
  let apps = read();
  if (!apps) {
    apps = SEED.slice();
    write(apps);
  }
  return apps;
}

function getById(id) {
  return getAll().find((a) => a.id === id) || null;
}

function slugify(s) {
  return (s || '')
    .toLowerCase()
    .trim()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '')
    .slice(0, 32) || 'app';
}

function uniqueSlug(base, ignoreId) {
  const apps = getAll();
  const ids = new Set(apps.filter((a) => a.id !== ignoreId).map((a) => a.id));
  const baseSlug = slugify(base);
  let slug = baseSlug;
  let n = 2;
  while (ids.has(slug)) {
    slug = `${baseSlug}-${n}`;
    n += 1;
  }
  return slug;
}

function add(input) {
  const apps = getAll();
  const id = uniqueSlug(input.id || input.name);
  const next = {
    id,
    name: input.name || 'Untitled',
    tagline: input.tagline || '',
    description: input.description || '',
    status: input.status || 'In progress',
    year: input.year || String(new Date().getFullYear()),
    featured: !!input.featured,
    color: input.color || '#F1EEE8',
    glyphFg: input.glyphFg || '#0A0A0A',
    glyph: (input.glyph || input.name || 'A').trim().charAt(0).toUpperCase(),
    appleLink: input.appleLink || '',
    googleLink: input.googleLink || '',
    websiteLink: input.websiteLink || '',
    version: input.version || '—',
    updated: 'just now',
  };
  apps.unshift(next);
  write(apps);
  return next;
}

function update(id, patch) {
  const apps = getAll();
  const idx = apps.findIndex((a) => a.id === id);
  if (idx < 0) return null;
  const merged = { ...apps[idx], ...patch, updated: 'just now' };
  if (patch.glyph) merged.glyph = patch.glyph.trim().charAt(0).toUpperCase();
  apps[idx] = merged;
  write(apps);
  return merged;
}

function remove(id) {
  const apps = getAll().filter((a) => a.id !== id);
  write(apps);
}

function reset() {
  write(SEED.slice());
}

function subscribe(fn) {
  const handler = () => fn(getAll());
  window.addEventListener('theunc:portfolio-changed', handler);
  const storageHandler = (e) => { if (e.key === KEY) fn(getAll()); };
  window.addEventListener('storage', storageHandler);
  return () => {
    window.removeEventListener('theunc:portfolio-changed', handler);
    window.removeEventListener('storage', storageHandler);
  };
}

const PortfolioStore = { getAll, getById, add, update, remove, reset, subscribe, slugify, uniqueSlug };
export default PortfolioStore;
